import React from 'react'
import PropTypes from 'prop-types';


const PlayerCompareStatsRow = ({ statsField, player1Stat, player2Stat }) => (
    <div className="compare-row col-xs-12">
        <div className="compare-cell col-xs-3 ">{player1Stat}</div>
        <div className="compare-cell compare-label vertical-delimiters col-xs-6">{statsField}</div>
        <div className="compare-cell col-xs-3 ">{player2Stat}</div>
    </div>
);

PlayerCompareStatsRow.propTypes = {
    statsField: PropTypes.string.isRequired,
    player1Stat: PropTypes.any.isRequired,
    player2Stat: PropTypes.any.isRequired
};

export default PlayerCompareStatsRow